import "./DirectionChangeIndicator.scss";
import {IComponentOptions, IOnChanges, IOnChangesObject} from "angular";
import {Optional} from "../../../js/util/Optional";

export const DirectionChangeIndicator = "tfDirectionChangeIndicator";

export function directionChangeIndicator(): IComponentOptions {
    return {
        templateUrl: "app/components/ui/change-indicator/DirectionChangeIndicator.html",
        bindings: {
            changeAmount: "<",
            invert: "<"
        },
        controllerAs: "ctrl",
        controller: DashboardPortfolioBalanceChangeIndicatorController
    };
}

const NO_CHANGE = "icon-circle-minus";
const CHANGE_UP = "icon-angle-double-up";
const CHANGE_DOWN = "icon-angle-double-down";

const GOOD = "summary-green";
const BAD = "summary-red";

export class DashboardPortfolioBalanceChangeIndicatorController implements IOnChanges {

    public changeAmount: number | null;
    public invert: boolean | null;

    public indicatorClass = NO_CHANGE;

    public $onChanges(changes: IOnChangesObject): void {
        const directionClass = this.directionClass();
        const directionColourClass = this.directionColour();
        this.indicatorClass = `${directionClass} ${ directionColourClass}`;
    }

    private directionClass(): string {
        if (this.changeAmount == null || this.changeAmount === 0) {
            return NO_CHANGE;
        } else if (this.changeAmount < 0) {
            return CHANGE_DOWN;
        } else {
            return CHANGE_UP;
        }
    }

    private directionColour(): string {
        const invert = Optional.of(this.invert).orElse(false);

        if (this.changeAmount == null || this.changeAmount === 0) {
            return "";
        } else if (this.changeAmount < 0 && invert) {
            return GOOD;
        } else if (this.changeAmount < 0 && !invert) {
            return BAD;
        } else if (this.changeAmount > 0 && invert) {
            return BAD;
        } else {
            return GOOD;
        }
    }
}
